import { MassMessageRolesGroup, RoleEntityType, MassMessageRole } from 'models';

export default function isRolesGroup(
  roleEntity: MassMessageRolesGroup | MassMessageRole
): roleEntity is MassMessageRolesGroup {
  return roleEntity.Type === RoleEntityType.Group;
}
